import { parseISO } from 'date-fns';

export function buildDate(date?: Date | string): Date | undefined {
    return typeof date === 'string'
        ? parseISO(date)
        : (date instanceof Date ? date : undefined);
}
